import ExpandableTransactionTable from './ExpandableTransactionTable';

export default ExpandableTransactionTable;